<template>
  <div class=" main-content mt-3 mx-3">
    <div class="grid">
        <div class="sm:col-12 md:col-9 lg:col-9 mt-2">
            <div >
                <label class=" ml-2 text-xl font-medium">Order No.: {{ orderNo }}</label>
            </div>
        </div>
        <div class="lg:col-3 md:col-3 sm:col-12 mt-2">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center">
                    <label class=" ml-2 text-xl font-medium">Summary</label>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <!-- <router-link to="/add-dept-po"  rel="noopener">
                        <Button label="New PO" icon="pi pi-plus" raised ></Button>
                    </router-link> -->
                </div>
            </div>
        </div>
        
    </div>

    <!-- <div class="grid">
        <div class="lg:col-9 md:col-9 sm:col-12">
            <div class="flex">
                <div class="flex-initial flex justify-content-center w-full">
                    <OrderDetailsTopSection :data="orderData"></OrderDetailsTopSection>
                </div>
            </div>
        </div>
        <div class="lg:col-3 md:col-3 sm:col-12">
            <div class="flex">
                <div class="flex-initial flex justify-content-center w-full">
                    <OrderDetailsAnalyticsComponent ></OrderDetailsAnalyticsComponent>
                </div>
            </div>
        </div>               
    </div> -->
    <!-- <div class="lg:col-9 md:col-9 sm:col-12">
        <div class="flex">
            <div class="flex-initial flex justify-content-center w-full">
                <ItemDetailsComponent></ItemDetailsComponent>
            </div>
        </div>
    </div> -->
    
    <div class="grid nested-grid">
        <div class="col-9">
            <div class="grid">
                <div class="col-12">
                    <div >
                    <OrderDetailsTopSection :data="orderData" :po="poData"></OrderDetailsTopSection>

                    </div>
                </div>
                
                <!-- <div class="col-12">
                    <div >
                <ItemDetailsComponent></ItemDetailsComponent>

                    </div>
                </div> -->
            </div>
        </div>
        <div class="col-3">
            <div >
                    <OrderDetailsAnalyticsComponent ></OrderDetailsAnalyticsComponent>

            </div>
        </div>
    </div>

  </div>
</template>

<script>
import { orderDetails } from '@/services/api/v2/apis';
import OrderDetailsTopSection from './orderDetailsTopSection.vue';
// import ItemDetailsComponent from './itemDetailsComponent.vue'
import { useDeptPoStore } from '@/stores/deptPoStore';
import OrderDetailsAnalyticsComponent from './orderDetailsAnalyticsComponent.vue'

export default {
    components:{
        OrderDetailsTopSection,
        // ItemDetailsComponent,
        OrderDetailsAnalyticsComponent
    },

    data(){
        return{
            orderNo:null,
            orderData:[],
            poData:null,
        }
    },
    methods:{
        async fetchOrderDetails(){            
            const response = await orderDetails(this.$route.params.id);
            this.orderData = response.data;            
        }
    },
    mounted(){
        
        this.fetchOrderDetails(); 
        const store = useDeptPoStore();
        store.loadData();        
        this.orderNo = (JSON.parse(store.data)).po_no; 
        this.poData = (JSON.parse(store.data));
    }

}
</script>

<style>

</style>